import { usePathname, useSearchParams } from 'next/navigation';
import {
  removeSessionStorage,
  setSessionStorage,
} from '@/common/sessionStorages';
import { useGetRegisterReturnUrl } from '@/modules/register/hooks';
import { useRegister } from '@/modules/register/hooks/useRegister';

const FESTIVAL_INVITE_LINK_STATIC_PART = '/festival/landing?inviteLink=http';

export const useHandleBeforeLogin = (regState: any) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { handleInitialLoginLogic } = useRegister();

  const { returnUrl } = useGetRegisterReturnUrl();

  const handleBeforeLogin = () => {
    if (regState?.newReg) {
      handleInitialLoginLogic(regState, returnUrl);
    } else if (pathname?.includes(FESTIVAL_INVITE_LINK_STATIC_PART)) {
      const inviteLinkQuery = searchParams?.get('inviteLink');
      if (inviteLinkQuery) {
        setSessionStorage('FI1LINK', inviteLinkQuery);
      }
    } else {
      removeSessionStorage('FI1LINK');
    }
  };

  return {
    handleBeforeLogin,
  };
};
